import { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { PlatformProvider } from './context/PlatformContext';
import BottomNav      from './components/BottomNav';
import DesktopSidebar from './components/DesktopSidebar';
import SlideMenu      from './components/SlideMenu';
import SupportChat    from './components/SupportChat';
import WaitlistPage   from './pages/WaitlistPage';
import LoginPage      from './pages/LoginPage';
import DashboardPage  from './pages/DashboardPage';
import BuyPage        from './pages/BuyPage';
import SendPage       from './pages/SendPage';
import CashoutPage    from './pages/CashoutPage';
import MovePage       from './pages/MovePage';
import PayPage        from './pages/PayPage';
import RequestPage    from './pages/RequestPage';
import SettingsPage      from './pages/SettingsPage';
import TaxPage           from './pages/TaxPage';
import IntegrationsPage  from './pages/IntegrationsPage';
import BankAccountsPage  from './pages/BankAccountsPage';
import TransactionsPage  from './pages/TransactionsPage';
import RecurringPage     from './pages/RecurringPage';
import TermsPage         from './pages/TermsPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';

const AUTHED_ROUTES = [
  '/dashboard','/buy','/send','/cashout','/move','/request',
  '/settings','/banks','/tax','/integrations',
  '/transactions','/recurring','/terms',
];

function PrivateRoute({ children }) {
  const { user } = useAuth();
  return user ? children : <Navigate to="/"/>;
}

function AppRoutes() {
  const { user } = useAuth();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);

  useState(() => {
    const handler = () => setIsDesktop(window.innerWidth >= 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  });

  const showNav = AUTHED_ROUTES.includes(location.pathname);

  return (
    <div style={isDesktop && user && showNav ? {display:'flex', minHeight:'100vh'} : {}}>
      {isDesktop && user && showNav && <DesktopSidebar/>}
      <div style={isDesktop && user && showNav ? {position:'fixed', right:0, top:0, bottom:0, left:240, minWidth:0, overflowY:'auto', background:'#F5F5F7'} : {}}>
        <Routes>
          <Route path="/"            element={<WaitlistPage/>}/>
          <Route path="/login"       element={user ? <Navigate to="/dashboard"/> : <LoginPage/>}/>
          <Route path="/dashboard"   element={<PrivateRoute><DashboardPage/></PrivateRoute>}/>
          <Route path="/buy"         element={<PrivateRoute><BuyPage/></PrivateRoute>}/>
          <Route path="/send"        element={<PrivateRoute><SendPage/></PrivateRoute>}/>
          <Route path="/cashout"     element={<PrivateRoute><CashoutPage/></PrivateRoute>}/>
          <Route path="/move"        element={<PrivateRoute><MovePage/></PrivateRoute>}/>
          <Route path="/request"     element={<PrivateRoute><RequestPage/></PrivateRoute>}/>
          <Route path="/settings"    element={<PrivateRoute><SettingsPage/></PrivateRoute>}/>
          <Route path="/banks"       element={<PrivateRoute><BankAccountsPage/></PrivateRoute>}/>
          <Route path="/tax"         element={<PrivateRoute><TaxPage/></PrivateRoute>}/>
          <Route path="/integrations"   element={<PrivateRoute><IntegrationsPage/></PrivateRoute>}/>
          <Route path="/transactions"   element={<PrivateRoute><TransactionsPage/></PrivateRoute>}/>
          <Route path="/recurring"      element={<PrivateRoute><RecurringPage/></PrivateRoute>}/>
          <Route path="/pay/:requestId" element={<PayPage/>}/>
          <Route path="/forgot-password" element={<ForgotPasswordPage/>}/>
          <Route path="/terms"       element={<TermsPage/>}/>
        </Routes>
        {showNav && user && !isDesktop && (
          <>
            <BottomNav onMenuOpen={() => setMenuOpen(true)}/>
            <SlideMenu open={menuOpen} onClose={() => setMenuOpen(false)}/>
          </>
        )}
        {showNav && user && <SupportChat/>}
      </div>
    </div>
  );
}

export default function App() {
  return (
    <PlatformProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes/>
        </BrowserRouter>
      </AuthProvider>
    </PlatformProvider>
  );
}
